import Layout from '../../components/feature/Layout';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Process from './components/Process';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';

export default function HomePage() {
  return (
    <Layout>
      <div className="min-h-screen bg-white">
        <Hero />
        <About />
        <Services />
        <Process />
        <Portfolio />
        <Testimonials />
        <CTA />
      </div>
    </Layout>
  );
}
